import { t } from "i18next";

export const REFRESH_BUTTON_TOOLTIP_PROPS = Object.freeze({
  content: t("neetoMolecules.versionHistory.refreshButtonTooltip"),
  position: "bottom",
});
